import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Buttton, Cards, Inputs } from "../../../components";
import {
  PiFirstAidLight,
  PiFilePdfThin,
  PiArrowLineUpRight,
  PiPlus,
} from "react-icons/pi";
import { RxCross2 } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AddAdditionalServices from "./addAdditionalServices";
import { actionDoctor, actionPatient } from "../../../redux/actions";
import { useAlert, useToast } from "../../../contexts";
import PatientInformationAndSymptoms from "./patientInformationAndSymptoms";
import { useTranslation } from "react-i18next";

const DiagnosticReportTab = ({ loginData, appointment, appointmentStatus }) => {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const fileInputRef1 = useRef(null);
  const { showAlert } = useAlert();
  const { showToast } = useToast();
  const location = useLocation();
  const onGoingChat = location.state?.onGoingChat;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    diagnosticReportGuid: null,
    appointmentGuid: null,
    describeProblem: "",
    diagnosticConclusion: "",
    prescribeMedicine: "",
    totalConsultAmount: 0,
    isClinicSchedule: false,
    createdDate: "",
    prescribeMedicineDocs: [
      {
        fileGuid: null,
        docName: "",
        docURL: "",
        isDeleted: false,
      },
    ],
    additionalDocuments: [
      {
        diagnosticAdditionalDocumentGuid: null,
        diagnosticReportGuid: null,
        additionalDocument: "",
        additionalFile: {
          fileGuid: null,
          docName: "",
          docURL: "",
          isDeleted: false,
        },
      },
    ],
    appDetail: {
      appointmentGuid: null,
      appointmentDate: "",
      patientName: "",
      doctorName: "",
      bookingid: "",
      consultfees: 0,
      continuechatfees: 0,
      doctorguid: "",
      patientguid: "",
      doctorimage: null,
      physicianservices: null,
      totalreview: 0,
      averagereview: 0,
      experience: 0,
      isfeedbackgiven: false,
      feedbackpendinghours: 0,
      refundpendinghours: 0,
      appointmentcurrency: "",
      clinicguid: null,
      isclinicschedule: false,
      admincommission: 0,
      doctorcommission: 0,
      clinicdoctoradmincommission: 0,
      suggesteddatetime: "",
      address: "",
      phone: "",
      email: "",
    },
    appointmentAdditionalServiceModel: [],
    appointmentClinicDoctorAdditionalServiceModel: [],
    secondRecentReport: {
      diagnosticReportGuid: null,
      appointmentGuid: null,
      describeProblem: "",
      diagnosticConclusion: "",
      prescribeMedicine: "",
      totalConsultAmount: 0,
      isClinicSchedule: false,
      createdDate: "",
    },
    secondRecentPrescribeMedicineDocs: [
      {
        fileGuid: null,
        docName: "",
        docURL: "",
        isDeleted: false,
      },
    ],
    secondRecentAdditionalDocuments: [
      {
        diagnosticAdditionalDocumentGuid: null,
        diagnosticReportGuid: null,
        additionalDocument: "",
        additionalFile: {
          fileGuid: null,
          docName: "",
          docURL: "",
          isDeleted: false,
        },
      },
    ],
    IsClinicSchedule: false,
  });
  const [errors, setErrors] = useState({});
  const getDiagnosticByIdData = useSelector(
    (state) => state.doctor.getDiagnosticByIdData?.data
  );
  const getAdditionalServiceInfoData = useSelector(
    (state) => state.doctor.getAdditionalServiceInfoData?.data
  );

  useEffect(() => {
    if (getAdditionalServiceInfoData && getDiagnosticByIdData) {
      const totalAmount =
        (getDiagnosticByIdData?.result?.appDetail?.consultFees || 0) +
        (getAdditionalServiceInfoData?.result?.totalAmount || 0);

      setCredentials((prev) => ({
        ...prev,
        totalConsultAmount: totalAmount,
      }));
    }
  }, [getAdditionalServiceInfoData, getDiagnosticByIdData]);

  useEffect(() => {
    if (appointment) {
      setCredentials((prevState) => ({
        ...prevState,
        appointmentGuid: appointment.appointmentGuid || null,
        appDetail: {
          ...prevState.appDetail,
          appointmentGuid: appointment.appointmentGuid || null,
          appointmentDate: appointment.appointmentDateTime || "",
          patientName: `${appointment.patientFirstName} ${appointment.patientLastName}`,
          doctorName: `${appointment.doctorFirstName} ${appointment.doctorLastName}`,
          bookingid: appointment.bookingId || "",
          consultfees: appointment.amount || 0,
          continuechatfees: appointment.continueChatFees || 0,
          doctorguid: appointment.doctorGuid || "",
          patientguid: appointment.patientGuid || "",
        },
        secondRecentReport: {
          ...prevState.secondRecentReport,
          appointmentGuid: appointment.appointmentGuid || null,
        },
      }));
    }
  }, [appointment]);
  useEffect(() => {
    if (getDiagnosticByIdData) {
      setCredentials((prev) => ({
        ...prev,
        prescribeMedicine: getDiagnosticByIdData?.result?.prescribeMedicine,
        diagnosticConclusion:
          getDiagnosticByIdData?.result?.diagnosticConclusion,
        describeProblem: getDiagnosticByIdData?.result?.describeProblem,
        createdDate: getDiagnosticByIdData?.result?.createdDate
          ? getDiagnosticByIdData?.result?.createdDate
          : new Date().toISOString().split(".")[0],

        appDetail: {
          ...prev.appDetail,
          admincommission:
            getDiagnosticByIdData?.result?.appDetail?.adminCommission || 0,
          suggesteddatetime:
            getDiagnosticByIdData?.result?.appDetail?.suggestedDateTime || "",
          address: getDiagnosticByIdData?.result?.appDetail?.address || "",
          phone: getDiagnosticByIdData?.result?.appDetail?.phone || "",
          email: getDiagnosticByIdData?.result?.appDetail?.email || "",
        },
        prescribeMedicineDocs:
          getDiagnosticByIdData.result.prescribeMedicineDocs?.length > 0
            ? getDiagnosticByIdData.result.prescribeMedicineDocs.map((doc) => ({
              fileGuid: null,
              docName: doc.docName,
              docURL: doc.docURL,
              isDeleted: doc.isDeleted,
            }))
            : [
              {
                fileGuid: null,
                docName: "",
                docURL: "",
                isDeleted: false,
              },
            ],
        additionalDocuments:
          getDiagnosticByIdData.result.additionalDocuments?.length > 0
            ? getDiagnosticByIdData.result.additionalDocuments.map((doc) => ({
              diagnosticAdditionalDocumentGuid: null,
              diagnosticReportGuid: null,
              additionalDocument: doc.additionalDocument,
              additionalFile: {
                fileGuid: null,
                docName: doc.additionalFile?.docName,
                docURL: doc.additionalFile?.docURL,
                isDeleted: doc.additionalFile?.isDeleted ?? false,
              },
            }))
            : [
              {
                diagnosticAdditionalDocumentGuid: null,
                diagnosticReportGuid: null,
                additionalDocument: "",
                additionalFile: {
                  fileGuid: null,
                  docName: "",
                  docURL: "",
                  isDeleted: false,
                },
              },
            ],
        secondRecentReport: {
          ...prev.secondRecentReport,
          diagnosticReportGuid:
            getDiagnosticByIdData?.result?.secondRecentReport
              ?.diagnosticReportGuid || null,
          createdDate:
            getDiagnosticByIdData?.result?.secondRecentReport?.createdDate,
          describeProblem:
            getDiagnosticByIdData?.result?.secondRecentReport?.describeProblem,
          diagnosticConclusion:
            getDiagnosticByIdData?.result?.secondRecentReport
              ?.diagnosticConclusion,
          prescribeMedicine:
            getDiagnosticByIdData?.result?.secondRecentReport
              ?.prescribeMedicine,
        },
        secondRecentPrescribeMedicineDocs: getDiagnosticByIdData?.result
          ?.secondRecentPrescribeMedicineDocs || [
            {
              fileGuid: null,
              docName: "",
              docURL: "",
              isDeleted: false,
            },
          ],
        secondRecentAdditionalDocuments:
          getDiagnosticByIdData?.result?.secondRecentAdditionalDocuments
            ?.length > 0
            ? getDiagnosticByIdData.result.secondRecentAdditionalDocuments
            : [
              {
                diagnosticAdditionalDocumentGuid: null,
                diagnosticReportGuid: null,
                additionalDocument: "",
                additionalFile: {
                  fileGuid: null,
                  docName: "",
                  docURL: "",
                  isDeleted: false,
                },
              },
            ],
      }));
    }
  }, [getDiagnosticByIdData]);
  const handleChange = (event) => {
    const { name, value } = event.target;

    setCredentials((prevCredentials) => ({
      ...prevCredentials,
      [name]: value,
    }));
  };

  const handleIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);

      dispatch(
        actionPatient.postUploadDocument(
          5,
          appointment?.appointmentGuid,
          formData,
          (error, response) => {
            if (error) {
            } else {
              setCredentials((prevState) => ({
                ...prevState,
                prescribeMedicineDocs: [
                  {
                    fileGuid: null,
                    docName: response?.data?.result?.data?.docName,
                    docURL: response?.data?.result?.data?.docURL,
                    isDeleted: false,
                  },
                ],
              }));

              showToast(
                `${t("success")}`,
                `${t("doctor.diagnostic_report.prescription_updated_successfully")}`,
                5000,
                true,
                "top-end toast-success"
              );
            }
          }
        )
      );
    }
  };

  const handleChangeDocument = (index, value) => {
    setCredentials((prevState) => ({
      ...prevState,
      additionalDocuments: prevState.additionalDocuments.map((doc, i) =>
        i === index ? { ...doc, additionalDocument: value } : doc
      ),
    }));
  };

  const handleFileUpload = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);

      dispatch(
        actionPatient.postUploadDocument(
          6,
          appointment?.appointmentGuid,
          formData,
          (error, response) => {
            if (error) {
            } else {
              setCredentials((prevState) => ({
                ...prevState,
                additionalDocuments: prevState.additionalDocuments.map(
                  (doc, i) =>
                    i === index
                      ? {
                        ...doc,
                        additionalFile: {
                          ...doc.additionalFile,
                          docName: response.data.result.data.docName,
                          docURL: response.data.result.data.docURL,
                          isDeleted: false,
                        },
                      }
                      : doc
                ),
              }));

              showToast(
                `${t("success")}`,
                `${t("doctor.diagnostic_report.additional_document_updated_successfully")}`,
                5000,
                true,
                "top-end toast-success"
              );
            }
          }
        )
      );
    }
  };

  const handleAddDocument = () => {
    setCredentials((prevState) => ({
      ...prevState,
      additionalDocuments: [
        ...prevState.additionalDocuments,
        {
          diagnosticAdditionalDocumentGuid: null,
          diagnosticReportGuid: null,
          additionalDocument: `New Object ${prevState.additionalDocuments.length + 1
            }`,
          additionalFile: {
            fileGuid: null,
            docName: "",
            docURL: "",
            isDeleted: false,
          },
        },
      ],
    }));
  };

  const handleRemoveDocument = (indexToRemove) => {
    setCredentials((prevState) => ({
      ...prevState,
      additionalDocuments: prevState.additionalDocuments.filter(
        (_, index) => index !== indexToRemove
      ),
    }));
  };

  const handleSubmit = () => {
    dispatch(
      actionDoctor.postDiagnosticReport(credentials, (error, response) => {
        if (error) {
          if (error.data) {
            if (error.data.statusCode === 400) {
              if (error.data.error && error.data.error.ValidationErrors) {
                error.data.error.ValidationErrors.forEach((validationError) => {
                  console.error(
                    `${t("Field")}: ${validationError.Field} - ${t(
                      "Message"
                    )}: ${validationError.Message}`
                  );

                  showAlert(
                    "danger",
                    validationError.Message,
                    `${t("Error")} : ${validationError.Field}`
                  );
                });
              } else {
                showAlert(
                  "danger",
                  t("Invalid_credentials"),
                  `${t("Error")} !`
                );
              }
            } else {
              showAlert("danger", t("unexpected_error"), `${t("Error")} !`);
            }
          }
        } else if (response) {
          if (response.status === 200) {
            showToast(
              `${t("success")}`,
              `${t("doctor.diagnostic_report.the_diagnostic_report_has_been_successfully_submitted")}`,
              5000,
              true,
              "top-end toast-success"
            );
            dispatch(
              actionDoctor.postMarkAppointmentAsComplete(
                appointment?.appointmentGuid,
                (error, response) => {
                  if (error) {
                    if (error.data) {
                      if (error.data.statusCode === 400) {
                        if (
                          error.data.error &&
                          error.data.error.ValidationErrors
                        ) {
                          error.data.error.ValidationErrors.forEach(
                            (validationError) => {
                              console.error(
                                `${t("Field")}: ${validationError.Field} - ${t(
                                  "Message"
                                )}: ${validationError.Message}`
                              );

                              showAlert(
                                "danger",
                                validationError.Message,
                                `${t("Error")} : ${validationError.Field}`
                              );
                            }
                          );
                        } else {
                          showAlert(
                            "danger",
                            t("Invalid_credentials"),
                            `${t("Error")} !`
                          );
                        }
                      } else {
                        showAlert(
                          "danger",
                          t("unexpected_error"),
                          `${t("Error")} !`
                        );
                      }
                    }
                  } else if (response) {
                    if (response.status === 200) {
                      if (onGoingChat !== 2) {
                        showAlert(
                          "secondary",
                          t("chatPage.appointment_completed_successfully"),
                          t("success"),
                        );
                        navigate("/doctor/appointment-completed/my-appointments");
                      }
                    }
                  } else {
                  }
                }
              )
            );
            dispatch(
              actionDoctor.getDiagnosticById(
                appointment?.appointmentGuid,
                loginData?.currencyCode
              )
            );
            dispatch(
              actionDoctor.getAdditionalServiceInfo(
                appointment?.appointmentGuid,
                loginData?.currencyCode
              )
            );

            if (onGoingChat === 2) {
              setTimeout(() => {
                dispatch(actionDoctor.postUpdateChatAppointment({
                  appointmentGuid: appointment?.appointmentGuid,
                  DoctorGuid: appointment?.doctorGuid,
                  Status: 3,
                  IsChatAccepted: true,
                  PatientGuid: appointment?.patientGuid,
                  ContinueChatStatus: 3
                }, (error, response) => {
                  if (error) {
                    if (error.data) {
                      if (error.data.statusCode === 400) {
                        if (error.data.error && error.data.error.ValidationErrors) {
                          error.data.error.ValidationErrors.forEach(
                            (validationError) => {
                              console.error(
                                `${t("Field")}: ${validationError.Field} - ${t(
                                  "Message"
                                )}: ${validationError.Message}`
                              );

                              showAlert(
                                "danger",
                                validationError.Message,
                                `${t("Error")} : ${validationError.Field}`
                              );
                            }
                          );
                        } else {
                          if (error.data.message) {
                            showAlert(
                              "danger",
                              error.data.message,
                              `${t("Error")} !`
                            );
                          } else {
                            showAlert(
                              "danger",
                              `${t("Invalid_credentials")}`,
                              `${t("Error")} !`
                            );
                          }

                        }
                      } else {
                        showAlert(
                          "danger",
                          `${t("unexpected_error")}``${t("Error")} !`
                        );
                      }
                    }
                  } else if (response) {
                    if (response.status === 200) {
                      showAlert("secondary", t("chatPage.chat_end_successfully"), "Info !");
                      dispatch(actionDoctor.postUpdateChatNotification({
                        appointmentGuid: appointment?.appointmentGuid,
                        userType: 2,
                        isRead: true
                      }, (error, response) => {
                        if (error) {
                          if (error.data) {
                            if (error.data.statusCode === 400) {
                              if (error.data.error && error.data.error.ValidationErrors) {
                                error.data.error.ValidationErrors.forEach(
                                  (validationError) => {
                                    console.error(
                                      `${t("Field")}: ${validationError.Field} - ${t(
                                        "Message"
                                      )}: ${validationError.Message}`
                                    );

                                    showAlert(
                                      "danger",
                                      validationError.Message,
                                      `${t("Error")} : ${validationError.Field}`
                                    );
                                  }
                                );
                              } else {
                                if (error.data.message) {
                                  showAlert(
                                    "danger",
                                    error.data.message,
                                    `${t("Error")} !`
                                  );
                                } else {
                                  showAlert(
                                    "danger",
                                    `${t("Invalid_credentials")}`,
                                    `${t("Error")} !`
                                  );
                                }

                              }
                            } else {
                              showAlert(
                                "danger",
                                `${t("unexpected_error")}``${t("Error")} !`
                              );
                            }
                          }
                        } else if (response) {
                          if (response.status === 200) {
                            navigate("/doctor/chat-completed", {
                              state: { chat: appointment }
                            });

                          }
                        }
                      }));
                    }
                  }
                }));
              }, 500);
            }



          }

        }
      })
    );
  };
  return (
    <>
      {appointmentStatus === 2 && (
        <PatientInformationAndSymptoms loginData={loginData} />
      )}

      <Row className="exado-sub-row1">
        <Col md={5}>
          <Cards.Cardd
            header={
              <>
                <div className="blkIcon">
                  <PiFirstAidLight className="iicon" />
                </div>
                <div>
                  <h5 className="exado-title-seven card-header-text">
                    {t(
                      "doctor.diagnostic_report.previous_description_of_anamnesis_and_investigations"
                    )}
                  </h5>
                  <span className="exado_body_text_two card-header-text">
                    {t("doctor.diagnostic_report.last_visit")}{" "}
                    {new Date(
                      credentials.secondRecentReport.createdDate
                    ).toLocaleDateString("en-GB")}
                  </span>
                </div>
              </>
            }
            content={credentials.secondRecentReport.describeProblem}
            className="cardd cardd-read-only"
          />
        </Col>
        <Col md={7}>
          <Cards.Cardd
            header={
              <>
                <div className="blkIcon">
                  <PiFirstAidLight className="iicon" />
                </div>
                <div>
                  <h5 className="exado-title-seven card-header-text">
                    {t(
                      "doctor.diagnostic_report.write_current_anamnesis_and_investigations"
                    )}
                  </h5>
                  <span className="exado_body_text_two card-header-text">
                    {t("doctor.diagnostic_report.current_date")}{" "}
                    {new Date(credentials.createdDate).toLocaleDateString(
                      "en-GB"
                    )}
                  </span>
                </div>
              </>
            }
            content={
              <Inputs.FormInputs
                type="textarea"
                placeholder=""
                label={
                  errors.aboutClinic ? (
                    <span className="error-message">{errors.aboutClinic}</span>
                  ) : (
                    `${t("doctor.diagnostic_report.enter_current_anamnesis_and_investigations")}`
                  )
                }
                name="describeProblem"
                value={credentials.describeProblem}
                onChange={handleChange}
                grpClassname={`form-group ${errors.aboutClinic ? "form-group-error" : ""
                  }`}
              // disabled={!isEditVisible}
              />
            }
            className="cardd"
          />
        </Col>
      </Row>
      <Row className="exado-sub-row1">
        <Col md={5}>
          <Cards.Cardd
            header={
              <>
                <div className="blkIcon">
                  <PiFirstAidLight className="iicon" />
                </div>
                <div>
                  <h5 className="exado-title-seven card-header-text">
                    {t(
                      "doctor.diagnostic_report.previous_description_of_diagnostic_conclusion"
                    )}
                  </h5>
                  <span className="exado_body_text_two card-header-text">
                    {t("doctor.diagnostic_report.last_visit")}{" "}
                    {new Date(
                      credentials.secondRecentReport.createdDate
                    ).toLocaleDateString("en-GB")}
                  </span>
                </div>
              </>
            }
            content={credentials.secondRecentReport.diagnosticConclusion}
            className="cardd cardd-read-only"
          />
        </Col>
        <Col md={7}>
          <Cards.Cardd
            header={
              <>
                <div className="blkIcon">
                  <PiFirstAidLight className="iicon" />
                </div>
                <div>
                  <h5 className="exado-title-seven card-header-text">
                    {t(
                      "doctor.diagnostic_report.write_current_diagnostic_conclusion"
                    )}

                  </h5>
                  <span className="exado_body_text_two card-header-text">
                    {t("doctor.diagnostic_report.current_date")}{" "}
                    {new Date(credentials.createdDate).toLocaleDateString(
                      "en-GB"
                    )}
                  </span>
                </div>
              </>
            }
            content={
              <Inputs.FormInputs
                type="textarea"
                placeholder=""
                label={
                  errors.aboutClinic ? (
                    <span className="error-message">{errors.aboutClinic}</span>
                  ) : (
                    `${t("doctor.diagnostic_report.enter_current_diagnostic_conclusion")}`
                  )
                }
                name="diagnosticConclusion"
                value={credentials.diagnosticConclusion}
                onChange={handleChange}
                grpClassname={`form-group ${errors.aboutClinic ? "form-group-error" : ""
                  }`}
              // disabled={!isEditVisible}
              />
            }
            className="cardd"
          />
        </Col>
      </Row>
      <Row className="exado-sub-row1">
        <Col md={5}>
          <Cards.Cardd
            header={
              <>
                <div className="blkIcon">
                  <PiFirstAidLight className="iicon" />
                </div>
                <div>
                  <h5 className="exado-title-seven card-header-text">
                    {t("doctor.diagnostic_report.suggested_prescription")}
                  </h5>
                  <span className="exado_body_text_two card-header-text">
                    {t("doctor.diagnostic_report.last_visit")}{" "}
                    {new Date(
                      credentials.secondRecentReport.createdDate
                    ).toLocaleDateString("en-GB")}
                  </span>
                </div>
              </>
            }
            content={credentials.secondRecentReport.prescribeMedicine}
            footer={
              <>
                {credentials.secondRecentPrescribeMedicineDocs?.map(
                  (doc, index) => (
                    <Link
                      key={index}
                      to={doc.docURL}
                      target="_blank"
                      className="exado-title-seven"
                    >
                      <PiFilePdfThin className="pdficon" />
                      {doc.docName.length > 20
                        ? doc.docName.substring(0, 20) + "..."
                        : doc.docName}
                    </Link>
                  )
                )}
              </>
            }
            className="cardd cardd-read-only cardd-prescreption-read-only"
          />
        </Col>
        <Col md={7}>
          <Cards.Cardd
            header={
              <>
                <div className="blkIcon">
                  <PiFirstAidLight className="iicon" />
                </div>
                <div>
                  <h5 className="exado-title-seven card-header-text">
                    {t("doctor.diagnostic_report.add_current_prescription")}
                  </h5>
                  <span className="exado_body_text_two card-header-text">
                    {t("doctor.diagnostic_report.current_date")}{" "}
                    {new Date(credentials.createdDate).toLocaleDateString(
                      "en-GB"
                    )}
                  </span>
                </div>
              </>
            }
            title={
              <>
                <PiArrowLineUpRight
                  className="custom-cursor-pointer"
                  onClick={handleIconClick}
                />{" "}
                <input
                  type="file"
                  ref={fileInputRef}
                  // style={{ display: "none" }}
                  className="d-none"
                  onChange={handleFileChange}
                />{" "}
              </>
            }
            content={
              <Inputs.FormInputs
                type="textarea"
                placeholder=""
                label={
                  errors.aboutClinic ? (
                    <span className="error-message">{errors.aboutClinic}</span>
                  ) : (
                    `${t("doctor.diagnostic_report.enter_current_suggested_prescription")}`
                  )
                }
                name="prescribeMedicine"
                value={credentials.prescribeMedicine}
                onChange={handleChange}
                grpClassname={`form-group ${errors.aboutClinic ? "form-group-error" : ""
                  }`}
              // disabled={!isEditVisible}
              />
            }
            footer={
              <>
                {credentials.prescribeMedicineDocs?.length > 0 &&
                  credentials.prescribeMedicineDocs.map((doc, index) => (
                    <Link
                      key={index}
                      to={doc.docURL}
                      target="_blank"
                      className="exado-title-seven"
                    >
                      <PiFilePdfThin className="pdficon" />
                      {doc.docName?.length > 50
                        ? doc.docName.substring(0, 50) + "..."
                        : doc.docName || ""}
                    </Link>
                  ))}
              </>
            }
            className="cardd card-prescription"
          />
        </Col>
      </Row>
      <Row className="exado-sub-row1">
        <Col md={5}>
          <Row>
            {credentials.secondRecentAdditionalDocuments?.map((doc, index) => (
              <Col key={index} md={12} className="col-additional-card">
                <Cards.Cardd
                  header={
                    index === 0 && (
                      <>
                        <div className="blkIcon">
                          <PiFirstAidLight className="iicon" />
                        </div>
                        <div>
                          <h5 className="exado-title-seven card-header-text">
                            {t("doctor.diagnostic_report.suggested_additional_documents")}
                          </h5>
                          <span className="exado_body_text_two card-header-text">
                            {t("doctor.diagnostic_report.last_visit")}{" "}
                            {new Date(
                              credentials.secondRecentReport.createdDate
                            ).toLocaleDateString("en-GB")}
                          </span>
                        </div>
                      </>
                    )
                  }
                  content={doc.additionalDocument}
                  footer={
                    <>
                      {doc.additionalFile?.docURL && (
                        <Link
                          to={doc.additionalFile.docURL}
                          target="_blank"
                          className="exado-title-seven"
                        >
                          <PiFilePdfThin className="pdficon" />
                          {doc.additionalFile.docName?.length > 20
                            ? doc.additionalFile.docName.substring(0, 20) +
                            "..."
                            : doc.additionalFile.docName || "View Document"}
                        </Link>
                      )}
                    </>
                  }
                  className="cardd cardd-read-only cardd-additinal-read-only"
                />
              </Col>
            ))}
          </Row>
        </Col>
        <Col md={7}>
          <Row>
            {credentials?.additionalDocuments.map((doc, index) => (
              <Col md={12} key={index} className="col-card-additional-document">
                <Cards.Cardd
                  header={
                    <>
                      <div className="card-header-heading">
                        <div className="blkIcon">
                          <PiFirstAidLight className="iicon" />
                        </div>
                        <h5 className="exado-title-seven card-header-text">
                          {t("doctor.diagnostic_report.add_current_additional_documents")}
                        </h5>
                      </div>

                      {index !== 0 && (
                        <div className="custom-cursor-pointer">
                          <RxCross2
                            onClick={() => handleRemoveDocument(index)}
                          />
                        </div>
                      )}
                    </>
                  }
                  title={
                    <>
                      <PiArrowLineUpRight
                        className="custom-cursor-pointer"
                        onClick={() => fileInputRef1.current?.click()}
                      />
                      <input
                        type="file"
                        ref={fileInputRef1}
                        className="d-none"
                        onChange={(e) => handleFileUpload(e, index)}
                      />{" "}
                    </>
                  }
                  content={
                    <Inputs.FormInputs
                      type="textarea"
                      placeholder=""
                      label={
                        errors.aboutClinic ? (
                          <span className="error-message">
                            {errors.aboutClinic}
                          </span>
                        ) : (
                          `${t("doctor.diagnostic_report.enter_current_suggested_prescription")}`
                        )
                      }
                      name="additionalDocument"
                      value={doc.additionalDocument}
                      onChange={(e) =>
                        handleChangeDocument(index, e.target.value)
                      }
                      grpClassname={`form-group ${errors.aboutClinic ? "form-group-error" : ""
                        }`}
                    // disabled={!isEditVisible}
                    />
                  }
                  footer={
                    doc.additionalFile.docURL && (
                      <Link
                        key={index}
                        to={doc.additionalFile.docURL}
                        target="_blank"
                        className="exado-title-seven"
                      >
                        <PiFilePdfThin className="pdficon" />
                        {doc.additionalFile.docName?.length > 50
                          ? doc.additionalFile.docName.substring(0, 50) + "..."
                          : doc.additionalFile.docName || "View Document"}
                      </Link>
                    )
                  }
                  className="cardd cardd-additional"
                />
              </Col>
            ))}
            <div className="add-new-document ">
              <span
                className="custom-cursor-pointer"
                onClick={handleAddDocument}
              >
                <PiPlus className="adn-icn" />
                {t("doctor.diagnostic_report.add_new")}
              </span>
            </div>
          </Row>
        </Col>
      </Row>
      <Row className="exado-sub-row1">
        <Col>
          <AddAdditionalServices
            loginData={loginData}
            credentials={credentials}
            setCredentials={setCredentials}
            appointment={appointment}
          />
        </Col>
      </Row>
      <Row className="exado-sub-row1 scgivdr-row">
        <Col md={12} className="scgivdr-col">
          <h2 className="exado-title-three">{t("doctor.diagnostic_report.close_diagnostic_report")}</h2>
        </Col>
        <Col md="auto">
          <Buttton.Buttton
            children={t("SUBMIT")}
            className="btn-solid-Aqua_Teal"
            onClick={handleSubmit}
          />
        </Col>
        <Col md="auto">
          <Buttton.Buttton children={t("CANCEL")} className="btn-border-Aqua_Teal" onClick={() => navigate(-1)} />
        </Col>
        <Col md="auto">
          <Buttton.Buttton
            children={t("doctor.diagnostic_report.GENERATE_INVOICE")}
            className="btn-border-Aqua_Teal"
          />
        </Col>
      </Row>
    </>
  );
};

export default DiagnosticReportTab;
